import * as React from 'react';

const STEP1 = {
  target: '[data-tour="my-incomes__ndfl2"]',
  content: <p>Страница со справками о доходах по форме 2-НДФЛ, полученными от работодателя.</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP2 = {
  target: '[data-tour="my-incomes__declIncome"]',
  content: <p>Страница со сведениями из декларации на прибыль, полученными от работодателя.</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP3 = {
  target: '[data-tour="my-incomes__insuranceTaxes"]',
  content: (
    <p>Страница со сведениями из расчетов по страховым взносам, предоставленных работодателем.</p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP4 = {
  target: '[data-tour="mainmenu__objects"]',
  content: <p>Раздел с детальной информацией по имуществу</p>,
  hideCloseButton: true,
  disableBeacon: true,
};

const STEPS_MY_INCOMES = [STEP1, STEP2, STEP3, STEP4];
export default STEPS_MY_INCOMES;
